import { render, staticRenderFns } from "./AddUserOptions.vue?vue&type=template&id=54d1bdf6&scoped=true"
import script from "./AddUserOptions.vue?vue&type=script&lang=js"
export * from "./AddUserOptions.vue?vue&type=script&lang=js"
import style0 from "./AddUserOptions.vue?vue&type=style&index=0&id=54d1bdf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d1bdf6",
  null
  
)

export default component.exports